import { render, staticRenderFns } from "./EditEmpleado.vue?vue&type=template&id=5ac3af2b&"
import script from "./EditEmpleado.vue?vue&type=script&lang=js&"
export * from "./EditEmpleado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditEmpleado.vue"
export default component.exports